import React, { Component } from 'react';
import { motion } from 'framer-motion';
import { Database, CheckCircle2, Globe, Zap } from 'lucide-react';
export function CmsSection() {
  const cmsPoints = ['Centralized system for managing all Special Offers', 'One input point for all languages', 'Faster campaign rollout and updates', 'More flexible and user-friendly than AEM', 'Continuous UX and conversion optimization', 'Reduces dependency on AEM development cycles'];
  return <section className="h-full flex items-center py-8 px-4 sm:px-6 lg:px-8 bg-white overflow-y-auto lg:overflow-hidden" data-id="element-17">
      <div className="max-w-6xl mx-auto w-full" data-id="element-18">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        ease: 'easeOut'
      }} className="mb-8" data-id="element-19">
          <span className="text-xs font-bold tracking-widest text-[#80BC41] uppercase mb-3 block" data-id="element-20">
            03 — CMS
          </span>
          <h2 className="text-3xl md:text-5xl font-bold text-[#1a1a1a] font-heading" data-id="element-21">
            One system. All offers. All languages.
          </h2>
        </motion.div>

        <div className="grid lg:grid-cols-2 gap-8 lg:gap-14 items-start" data-id="element-22">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.1,
          ease: 'easeOut'
        }} data-id="element-23">
            <div className="bg-white p-6 md:p-8 rounded-2xl border-2 border-[#80BC41]/20 relative" data-id="element-24">
              <div className="absolute -top-3 left-6" data-id="element-25">
                <span className="bg-[#80BC41] text-white text-[10px] font-bold px-3 py-1 rounded-full uppercase tracking-wider" data-id="element-26">
                  Core Component
                </span>
              </div>
              <h3 className="text-base font-bold text-[#1a1a1a] mb-5 mt-1 flex items-center gap-2" data-id="element-27">
                <Database className="w-5 h-5 text-[#80BC41]" data-id="element-28" />
                October CMS
              </h3>
              <ul className="space-y-3" data-id="element-29">
                {cmsPoints.map((point, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-30">
                    <CheckCircle2 className="w-5 h-5 text-[#80BC41] shrink-0 mt-0.5" data-id="element-31" />
                    <span className="text-gray-700 font-medium text-sm" data-id="element-32">
                      {point}
                    </span>
                  </li>)}
              </ul>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.2,
          ease: 'easeOut'
        }} className="space-y-6" data-id="element-33">
            <div className="bg-gray-50 p-6 rounded-2xl border border-gray-100" data-id="element-34">
              <h4 className="text-xs font-bold tracking-widest text-[#EB0A1E] uppercase mb-4" data-id="element-35">
                Beyond Special Offers
              </h4>
              <div className="space-y-4" data-id="element-36">
                <div className="flex items-start gap-3" data-id="element-37">
                  <Globe className="w-5 h-5 text-[#80BC41] shrink-0 mt-0.5" data-id="element-38" />
                  <span className="text-gray-700 font-medium text-sm" data-id="element-39">
                    Extend to other Toyota campaign pages and landing pages
                  </span>
                </div>
                <div className="flex items-start gap-3" data-id="element-40">
                  <Zap className="w-5 h-5 text-[#80BC41] shrink-0 mt-0.5" data-id="element-41" />
                  <span className="text-gray-700 font-medium text-sm" data-id="element-42">
                    Build a flexible campaign ecosystem outside AEM limitations
                  </span>
                </div>
              </div>
            </div>

            <div className="bg-[#1a1a1a] p-6 rounded-2xl text-white" data-id="element-43">
              <h4 className="text-xs font-bold tracking-widest text-[#EB0A1E] uppercase mb-4" data-id="element-44">
                How It Works
              </h4>
              <div className="space-y-3 text-sm" data-id="element-45">
                <div className="flex items-center gap-3" data-id="element-46">
                  <span className="w-6 h-6 rounded-full bg-white/10 flex items-center justify-center text-xs font-bold shrink-0" data-id="element-47">
                    1
                  </span>
                  <span className="text-gray-300" data-id="element-48">
                    Build page in CMS with modular components
                  </span>
                </div>
                <div className="flex items-center gap-3" data-id="element-49">
                  <span className="w-6 h-6 rounded-full bg-white/10 flex items-center justify-center text-xs font-bold shrink-0" data-id="element-50">
                    2
                  </span>
                  <span className="text-gray-300" data-id="element-51">
                    CMS outputs optimized script + HTML
                  </span>
                </div>
                <div className="flex items-center gap-3" data-id="element-52">
                  <span className="w-6 h-6 rounded-full bg-white/10 flex items-center justify-center text-xs font-bold shrink-0" data-id="element-53">
                    3
                  </span>
                  <span className="text-gray-300" data-id="element-54">
                    Paste into AEM page — done
                  </span>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}